module.exports = __webpack_public_path__ + "img/blog-2.12fc4705.webp";